import { IconCart } from '@/components/icons'
import { formatMoney } from '@/lib/money'
import { cn } from '@/lib/utils'

type Props = {
  unitCount: number
  total: number
  currency: string
  onOpen: () => void
}

export function PosMobileCartBar({ unitCount, total, currency, onOpen }: Props) {
  return (
    <div
      className={cn(
        'border-border bg-background/95 fixed inset-x-0 bottom-0 z-20 border-t px-4 py-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] backdrop-blur-sm',
        'lg:hidden',
        'pb-[max(0.75rem,env(safe-area-inset-bottom))]',
      )}
    >
      <button
        type="button"
        onClick={onOpen}
        className={cn(
          'bg-primary text-primary-foreground flex min-h-12 w-full items-center justify-between gap-3 rounded-2xl px-4 py-3 text-base font-semibold shadow-sm transition',
          'active:scale-[0.99] motion-reduce:active:scale-100',
          'focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
        )}
        aria-label={
          unitCount > 0
            ? `Open cart — ${unitCount} items, total ${formatMoney(total, currency)}`
            : 'Open cart — empty'
        }
      >
        <span className="flex items-center gap-2">
          <IconCart className="h-5 w-5 shrink-0" aria-hidden />
          <span className="tabular-nums">{unitCount > 99 ? '99+' : unitCount} items</span>
        </span>
        <span className="tabular-nums">{formatMoney(total, currency)}</span>
      </button>
    </div>
  )
}
